<template>
    <div>
        <b-container fluid>
            <div style="display:flex; justify-content: space-between; align-items: center;">
                <h3 class="mt-3 mb-3">Packing Log</h3>
                <b-button class="btn-action" size="sm" variant="info" @click="exportXLS">Export XLS</b-button>
            </div>
            <div class="row">

                <div class="col-3">
                    <b-form-input size="md" type="text" v-model="packing_process_obj.tracking_number"
                        ref="txt_tracking_number" placeholder="Tracking #"
                        v-on:keyup.enter="onSubmit(packing_process_obj.tracking_number)" />
                </div>

                <div class="col-3">
                    <b-button class="btn-action" size="md" variant="info"
                        @click="onSubmit(packing_process_obj.tracking_number)" v-if="
                            checkPermission(
                                $store.state.user_obj,
                                'Warehouse Management',
                                'Packing Process',
                                'Update Status',
                                true
                            )
                        ">Submit</b-button>
                </div>
            </div>

            <div class="row mt-2">
                <div class="col">
                    <b-alert :show="alert_config.show" :variant="alert_config.variant"
                        @dismissed="alert_config.show = false" dismissible>
                        {{ alert_config.message }}
                    </b-alert>
                </div>
            </div>

            <!-- <p class="decode-result mt-3">
                Last result: <b>{{ result }}</b>
            </p> -->

            <div class="row m-1" v-if="scannerOn">
                <b-button block class="btn-action mb-1" size="md" variant="danger" @click="closeScanner()"
                    v-if="scannerOn">Close</b-button>
                <StreamBarcodeReader style="width: 100%;" @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader>
            </div>

            <h4>Scan History</h4>
            <b-table responsive small outlined striped hover sticky-header="500px" :items="scan_history">
            </b-table>
        </b-container>
    </div>
</template>

<script>
import moment from "moment";
import VueBarcode from "vue-barcode";
import apiService from "../services/ApiService";
import global_function from "../mixins/global_function";
import { StreamBarcodeReader } from "vue-barcode-reader";

export default {
    name: "OrderMaster",
    inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT", "NODEJS_API_URL"],
    mixins: [apiService, global_function],
    components: {
        barcode: VueBarcode,
        StreamBarcodeReader
    },
    data() {
        return {
            result: null,
            packing_process_obj: {
                packing_status: "start_picking",
                tracking_number: null
            },

            scan_history: [],

            scannerOn: false,

            alert_config: {
                show: false,
                variant: "danger",
                message: ""
            },

            fields: [
                {
                    key: "date",
                    label: "Date"
                },
                {
                    key: "time",
                    label: "Time"
                },
                {
                    key: "tracking_number",
                    label: "Tracking #"
                }
            ],

            camera_cooldown: false,
        };
    },
    async created() {
        this.initialized = true;
        this.packing_process_get();
    },
    mounted() {
        this.$refs["txt_tracking_number"].$el.focus();
    },
    watch: {},
    methods: {
        async onDecode(content) {
            if (this.scannerOn && !this.camera_cooldown) {
                this.result = content;
                this.onSubmit(content);
            }
        },
        onLoaded() {
            console.log("loaded barcode reader");
        },
        async onSubmit(tracking_number) {
            this.alert_config = {
                show: false,
                variant: "danger",
                message: ""
            };
            // this.scannerOn = false;
            // alert('Tracking #: '+tracking_number);

            if (!tracking_number || tracking_number === "") return;

            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "packing_process_scan.php",
                data: {
                    scanner_input_obj: {
                        ...this.scanner_input_obj,
                        tracking_number
                    },
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id
                }
            });

            this.camera_cooldown = true;
            setTimeout(() => this.camera_cooldown = false, 2000);

            if (response.data.status === "success") {
                this.alert_config = {
                    show: true,
                    variant: "success",
                    message: "Logged Successful"
                };

                console.log(response.data.orders);

                this.packing_process_obj = {
                    packing_status: "start_picking",
                    tracking_number: null
                };

                this.packing_process_get();

                this.$refs["txt_tracking_number"].$el.focus();
            } else {
                this.alert_config = {
                    show: true,
                    variant: "danger",
                    message: `[${tracking_number}] ${response.data.message}`
                };
            }
        },
        openScanner() {
            this.scannerOn = true;
        },
        closeScanner() {
            this.scannerOn = false;
        },
        async packing_process_get() {
            let response = await this.$http({
                method: "POST",
                baseURL: `${this.API_HOST}`,
                url: "packing_process_get.php",
                data: {
                    user_id: this.$store.state.user_obj.user_id
                }
            });
            this.scan_history = response.data.logs;
        },

        exportXLS() {
            this.loader = this.$loading.show({
                isFullPage: true,
                canCancel: false,
            });

            // Get the current date in YYYYMMDD format
            const currentDate = new Date();
            const formattedDate = currentDate.getFullYear().toString() +
                (currentDate.getMonth() + 1).toString().padStart(2, '0') +
                currentDate.getDate().toString().padStart(2, '0');

            this.$http({
                url: this.NODEJS_API_URL + "/gen_excel",
                method: "POST",
                data: {
                    export_type: "packing_process", // Set export_type to packing_process
                    client_id: this.$store.state.user_obj.client_id,
                    user_id: this.$store.state.user_obj.user_id,
                },
                responseType: "blob", // important to handle binary response for file download
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement("a");
                link.href = url;
                // Set the file name with the current date in the format YYYYMMDD
                link.setAttribute("download", `packing_log_${formattedDate}.xlsx`);
                document.body.appendChild(link);
                link.click();

                this.loader.hide();
            }).catch((error) => {
                this.loader.hide();
                this.alert_config = {
                    show: true,
                    variant: "danger",
                    message: "An error occurred while exporting the file."
                };
                console.error(error);
            });
        }
    }
};
</script>

<style>
th,
td {
    white-space: nowrap;
}

.span-status {
    display: none;
}

.container-status:hover .span-status {
    display: inline;
}

.row-status_cnt {
    display: flex;
}

.scanner-container video {
    width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/PackingProcess.vue